/* import __COLOCATED_TEMPLATE__ from './details-header-component.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { HIDE_REINSTALL_APP_PACKAGE_IDS } from '../../app-package';

export default class DetailsHeaderComponent extends Component {
  @service appService;

  constructor() {
    super(...arguments);
  }

  get shouldShowReinstallBanner() {
    return (
      this.args.appPackage?.hasInstallStateUnhealthy &&
      !HIDE_REINSTALL_APP_PACKAGE_IDS.includes(this.args.appPackage?.id)
    );
  }
}
